import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { DashboardLayout, DashboardProjects } from '@components/Dashboard'
import type React from 'react'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

export const DashboardRoot: React.FC = () => (
  <AuthenticatedWrapper>
    <NotificationWrapper />
    <DashboardLayout>
      <DashboardProjects />
    </DashboardLayout>
    <SystemDialogs />
    <Modal />
  </AuthenticatedWrapper>
)
